import { MoedaInternacional, TipoOperacaoInternacional } from "./enum";

export default class PosicaoAtivoInternacional implements IPosicaoAtivoInternacional {
  public codigoAtivo!: string;
  public quantidade!: number;
  public custoMedioOriginal!: number;
  public custoMedioBRL!: number;
  public moeda!: MoedaInternacional;
  public valorTotalOriginal!: number;
  public valorTotalBRL!: number;
  // Direção da posição: SELL = vendida (lançamento). Docs antigos não têm
  // o campo e são sempre posições compradas.
  public tipoOperacao?: TipoOperacaoInternacional;

  constructor(param: IPosicaoAtivoInternacional) {
    Object.assign(this, param);
  }

  static fromFirestore(data: any): PosicaoAtivoInternacional {
    return new PosicaoAtivoInternacional({
      codigoAtivo: data.codigoAtivo,
      quantidade: data.quantidade,
      custoMedioOriginal: data.custoMedioOriginal,
      custoMedioBRL: data.custoMedioBRL,
      moeda: data.moeda as MoedaInternacional,
      valorTotalOriginal: data.valorTotalOriginal,
      valorTotalBRL: data.valorTotalBRL,
      tipoOperacao: data.tipoOperacao as TipoOperacaoInternacional | undefined,
    });
  }
}

interface IPosicaoAtivoInternacional {
  codigoAtivo: string;
  quantidade: number;
  custoMedioOriginal: number;
  custoMedioBRL: number;
  moeda: MoedaInternacional;
  valorTotalOriginal: number;
  valorTotalBRL: number;
  tipoOperacao?: TipoOperacaoInternacional;
}
